import { render, staticRenderFns } from "./UkFrontOfPackConfiguration.vue?vue&type=template&id=e6ea85c8&scoped=true"
import script from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UkFrontOfPackConfiguration.vue?vue&type=style&index=0&id=e6ea85c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ea85c8",
  null
  
)

export default component.exports